var _defs, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 613.693,
    height: 283.841,
    viewBox: "0 0 613.693 283.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b,.c,.d,.e{fill:#fff}.c{stroke:transparent}.d{opacity:.548}.e{opacity:.55}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-176.474 -1294.727)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.163
    },
    transform: "translate(-68.5 71.452)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.787 1339.234a4.66 4.66 0 0 1 2.045.511l54.2 31.393a4.12 4.12 0 0 1 2.041 3.579v62.582a4.39 4.39 0 0 1-2.045 3.579l-27.1 15.645-27.096 15.645a4.16 4.16 0 0 1-4.09 0l-54.2-31.393a4.12 4.12 0 0 1-2.045-3.579v-62.581a4.39 4.39 0 0 1 2.045-3.579l54.2-31.393a6.6 6.6 0 0 1 2.045-.409m50.105 37.835-50.106-29.041-50.106 29.041v57.878l50.107 29.041 50.105-28.939z",
    className: "b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.787 1313.261a4.1 4.1 0 0 1 4.09 4.091v25.973a4.09 4.09 0 1 1-8.181 0v-25.973a4.1 4.1 0 0 1 4.091-4.091M276.179 1418.483a4.3 4.3 0 0 1 2.147.614l33.234 20.349a4.035 4.035 0 0 1 1.329 5.624 4.035 4.035 0 0 1-5.624 1.329l-33.233-20.349a4.035 4.035 0 0 1-1.329-5.624 4.12 4.12 0 0 1 3.476-1.943M421.178 1472.398a4.66 4.66 0 0 1-2.045-.511l-54.2-31.393a4.12 4.12 0 0 1-2.045-3.579v-62.479a4.39 4.39 0 0 1 2.045-3.579l54.2-31.393a4.16 4.16 0 0 1 4.09 0l54.2 31.393a4.12 4.12 0 0 1 2.045 3.579v62.581a4.39 4.39 0 0 1-2.045 3.579l-54.2 31.393a4.6 4.6 0 0 1-2.045.409m-50.106-37.733 50.106 28.939 50.106-29.041v-57.775l-50.106-28.936-50.105 28.936Z",
    className: "b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M455.843 1387.934a4.3 4.3 0 0 1-2.147-.614l-33.234-20.349a4.086 4.086 0 1 1 4.295-6.953l33.233 20.349a4.089 4.089 0 0 1-2.147 7.567M699.214 1302.038a4.3 4.3 0 0 1-2.147-.614l-33.234-20.349a4.086 4.086 0 1 1 4.295-6.953l33.233 20.349a4.089 4.089 0 0 1-2.147 7.567",
    className: "b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M579.707 1376.796h-.031v-.008l-50.106-28.938-48.72 28.138-9.566-.078v-1.473a4.39 4.39 0 0 1 2.045-3.579l54.196-31.393a4.16 4.16 0 0 1 4.09 0l54.2 31.393a4 4 0 0 1 .36.235l-1.369 4.04s-1.215 1.663-4.989 1.663Z",
    className: "c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M664.549 1384.458a4.66 4.66 0 0 1-2.045-.511l-54.2-31.393a4.12 4.12 0 0 1-2.045-3.579v-62.479a4.39 4.39 0 0 1 2.045-3.579l54.2-31.393a4.16 4.16 0 0 1 4.09 0l54.2 31.393a4.12 4.12 0 0 1 2.045 3.579v62.581a4.39 4.39 0 0 1-2.045 3.579l-54.2 31.393a4.6 4.6 0 0 1-2.045.409m-50.106-37.733 50.106 28.939 50.106-29.041v-57.775l-50.106-28.936-50.105 28.936Z",
    className: "b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44.993,
    height: 8.181,
    className: "b",
    rx: 4.09,
    transform: "rotate(-42 2077.671 -64.32)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M821.545 1288.855h-.031v-.008l-50.106-28.938-48.72 28.138-9.566-.078v-1.473a4.39 4.39 0 0 1 2.045-3.579l54.196-31.393a4.16 4.16 0 0 1 4.09 0l54.2 31.393a4 4 0 0 1 .36.235l-1.369 4.04s-1.215 1.663-4.989 1.663Z",
    className: "c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M770.386 1223.275a4.1 4.1 0 0 1 4.09 4.091v25.973a4.09 4.09 0 1 1-8.181 0v-25.973a4.1 4.1 0 0 1 4.091-4.091M802.838 1273.482a4.14 4.14 0 0 1 5.585-1.672l22.014 12.71a4.14 4.14 0 0 1 1.344 5.672 4.14 4.14 0 0 1-5.584 1.672l-20.281-13.072c-1.906-1.1-4.244-3.29-3.078-5.31",
    className: "b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M828.677 1284.102a4.1 4.1 0 0 1 4.09 4.09v64.031a4.09 4.09 0 1 1-8.181 0v-64.031a4.1 4.1 0 0 1 4.091-4.09",
    className: "b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M825.612 1351.523a4.1 4.1 0 0 1 5.367-2.168l23.921 10.156a4.093 4.093 0 1 1-3.199 7.535l-23.92-10.156a4.1 4.1 0 0 1-2.169-5.367",
    className: "b"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.957,
    cy: 5.957,
    r: 5.957,
    className: "b",
    transform: "translate(426.219 1385.733)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.957,
    cy: 5.957,
    r: 5.957,
    className: "b",
    transform: "translate(366.925 1478.534)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.363,
    cy: 9.363,
    r: 9.363,
    className: "d",
    transform: "translate(290.367 1355.645)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.154,
    cy: 5.154,
    r: 5.154,
    className: "d",
    transform: "translate(288.953 1541.05)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.791,
    cy: 13.791,
    r: 13.791,
    className: "d",
    transform: "translate(490.033 1392.044)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.935,
    cy: 4.935,
    r: 4.935,
    className: "d",
    transform: "translate(361.4 1375.401)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "e",
    transform: "translate(538.718 1447.641)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "e",
    transform: "translate(387.342 1341.855)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.957,
    cy: 5.957,
    r: 5.957,
    className: "b",
    transform: "matrix(-1 0 0 -1 647.348 1497.479)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.957,
    cy: 5.957,
    r: 5.957,
    className: "b",
    transform: "matrix(-1 0 0 -1 706.642 1404.678)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.863,
    cy: 4.863,
    r: 4.863,
    className: "d",
    transform: "matrix(-1 0 0 -1 186.2 1402.567)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.154,
    cy: 15.154,
    r: 15.154,
    className: "d",
    transform: "matrix(-1 0 0 -1 788.615 1338.162)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.291,
    cy: 3.291,
    r: 3.291,
    className: "d",
    transform: "matrix(-1 0 0 -1 221.535 1405.168)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.935,
    cy: 4.935,
    r: 4.935,
    className: "d",
    transform: "matrix(-1 0 0 -1 712.168 1507.811)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "e",
    transform: "matrix(-1 0 0 -1 672.849 1322.571)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "e",
    transform: "matrix(-1 0 0 -1 686.225 1541.357)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.363,
    cy: 11.363,
    r: 11.363,
    className: "d",
    transform: "matrix(-1 0 0 -1 327.2 1578.567)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChem);
export default __webpack_public_path__ + "static/media/chem.bc4afb4d6bb96f76f73a43eb5861e43d.svg";
export { ForwardRef as ReactComponent };